/**
 * Form Permission Constants for the Forms MVP feature.
 *
 * These names mirror the rows inserted by the Prisma migration
 * `20260420120000_form_permissions` into the legacy `permissions` table.
 *
 * `PermissionControl` / `isPermitted` compare permission names with
 * `.toLowerCase()`, so the string values here must match the DB rows
 * exactly (lowercase, underscore-separated).
 */

// Forms list visibility (Feeds > Forms tab, Forms page).
export const FORM_READ = 'form_read';

// Authoring a new form in the Forms tab (Create New Form button, /forms route).
export const FORM_CREATE = 'form_create';

// Attaching an existing form to an announcement or message from the composer.
export const FORM_ATTACH = 'form_attach';
